export const AUTH_USER_SET = 'AUTH_USER_SET';
export const AUTH_USER_CLEAR = 'AUTH_USER_CLEAR';
export const AUTH_USER_UPDATE = 'AUTH_USER_UPDATE';
